var _style, _rect, _polygon, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 45",
    style: {
      enableBackground: "new 0 0 70 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0-uk{fill:#012169;}\r\n\t.st1-uk{fill:#FFFFFF;}\r\n\t.st2-uk{fill:none;}\r\n\t.st3-uk{fill:#C8102E;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Blue",
    className: "st0-uk",
    width: 70,
    height: 45
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "White",
    className: "st1-uk",
    points: "70,0 70,4.1 51.4,15.7 49.9,16.7 48.3,17.7 40.5,22.5 48.3,27.3 49.9,28.3 51.4,29.3  70,40.8 70,45 65.6,45 41.6,30 40.6,29.4 39.6,28.8 35,25.9 30.4,28.8 29.4,29.4 28.4,30 4.3,45 0,45 0,40.8 18.6,29.3 20.1,28.3  21.7,27.3 29.5,22.5 21.7,17.7 20.1,16.7 18.6,15.7 0,4.2 0,0 4.3,0 28.4,15 29.4,15.6 30.4,16.2 35,19.1 39.6,16.2 40.6,15.6  41.6,15 65.6,0 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cross2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2-uk",
    d: "M70,43.9L46.5,29.3l-1.6-1l-1.6-1l-8-5v0h0l-7.5-4.6l-1.6-1l-1.6-1L0.3,0.5 M0,44.3l24.1-15l1.6-1l1.6-1l8.1-5 l0,0h0l7.4-4.6l1.6-1l1.6-1L70,0.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3-uk",
    points: "35.3,22.3 31.6,22.3 24.2,17.7 22.6,16.7 21,15.7 0,2.6 0,0.4 0.3,0.5 24.7,15.7 26.2,16.7 27.8,17.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3-uk",
    points: "42.8,17.7 35.3,22.3 39,22.3 47,27.3 48.6,28.3 50.2,29.3 70,41.6 70,43.9 46.5,29.3 44.9,28.3  43.3,27.3 35.3,22.3 35.3,24.6 30.4,27.7 29.3,28.3 27.8,29.3 2.5,45 0,45 0,44.3 24.1,29.3 25.6,28.3 27.2,27.3 35.3,22.3  35.3,22.3 35.3,20 39.6,17.3 40.6,16.7 42.2,15.7 67.5,0 70,0 70,0.7 45.9,15.7 44.3,16.7  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Cross1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3-uk",
    points: "70,16.7 70,28.3 40.6,28.3 40.6,45 29.4,45 29.4,28.3 0,28.3 0,16.7 29.4,16.7 29.4,0 40.6,0  40.6,16.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1-uk",
    d: "M41.6,15.7V0h-1.9v17.7H70v-2H41.6z M28.4,0v15.7H0v2h30.4V0H28.4z M0,27.3v2h28.4V45h1.9V27.3H0z M39.6,27.3 V45h1.9V29.3H70v-2H39.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUk);
export default __webpack_public_path__ + "static/media/FlagUK.c4d1d988cc2171efa8ea29490493c74e.svg";
export { ForwardRef as ReactComponent };